<div class="results-table">
  <!-- Pinned labels -->
  <div class="results-table__pinned">
    <div class="results-table__header results-table__pinned-cell" [innerHTML]="hashHtml"></div>
    <div
      class="results-table__cell results-table__pinned-cell results-table__pinned-cell--outcome"
      [innerHTML]="outcomeHtml"
    ></div>
    <div
      class="results-table__cell results-table__pinned-cell results-table__pinned-cell--result"
      [innerHTML]="resultHtml"
    ></div>
  </div>

  <!-- Scrollable trial columns -->
  <div class="results-table__scroll" #scrollArea>
    @for (trial of results(); track trial.trialNumber) {
      <div
        class="results-table__column"
        [class.results-table__column--success]="trial.isSuccess"
        [class.results-table__column--loss]="!trial.isSuccess"
      >
        <div class="results-table__header">{{ trial.trialNumber }}</div>
        <div class="results-table__cell results-table__outcome-cell">
          <dojo-outcome-svg [svgType]="trial.outcome.svgType" />
        </div>
        <div
          class="results-table__cell results-table__result-cell"
          [class.results-table__result-cell--success]="trial.isSuccess"
          [class.results-table__result-cell--loss]="!trial.isSuccess"
        >
          {{ trial.isSuccess ? 'Success' : 'Loss' }}
        </div>
      </div>
    }
  </div>
</div>
